import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Paper, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { FaRecycle, FaUsers, FaBug, FaStar, FaTasks } from "react-icons/fa";

const MotionPaper = motion(Paper);

const DashboardStats = ({ stats }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const { all_reports, all_issues, all_reviews, all_users } = stats || {};

  const statItems = [
    { label: "Reports", value: all_reports?.total || 0, color: "#2e7d32", icon: "📢" },
    { label: "Issues", value: all_issues?.total || 0, color: "#0277bd", icon: <FaBug size={28} color="#0277bd" /> },
    { label: "Resolved", value: all_issues?.resolved || 0, color: "#ff9800", icon: <FaRecycle size={28} color="#ff9800" /> },
    { label: "In Progress", value: all_issues?.in_progress || 0, color: "#388e3c", icon: <FaTasks size={28} color="#388e3c" /> },
    { label: `(${all_reviews?.total || 0}) Reviews`, value: all_reviews?.average?.toFixed(1) || 0, color: "#00695c", icon: <FaStar size={28} color="#fbc02d" /> },
    { label: "Community", value: all_users?.total || 0, color: "#1b5e20", icon: <FaUsers size={28} color="#1b5e20" /> },
  ];

  // Auto-cycle active card (highlight only)
  // useEffect(() => {
  //   if (!isSmallScreen) return;

  //   const interval = setInterval(() => {
  //     setActiveIndex((prev) => (prev + 1) % statItems.length);
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [isSmallScreen, statItems.length]);

  if (!stats) return null;

  return (
    <Box mb={6} px={2} textAlign="center">
      {isSmallScreen ? (
        // 📱 Small screens: horizontal scroll (manual swipe + auto highlight)
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            gap: 2,
            p: 1,
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
          }}
        >
          {statItems.map((stat, i) => (
            <MotionPaper
              key={i}
              className="stat-card"
              elevation={5}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              whileHover={{ scale: 1.05 }}
              sx={{
                p: 3,
                borderRadius: "18px",
                textAlign: "center",
                background: "#ffffff",
                minWidth: "240px",
                flex: "0 0 auto",
                boxShadow: "0px 4px 12px rgba(46,125,50,0.15)",
                scrollSnapAlign: "center",
                border: i === activeIndex ? `3px solid ${stat.color}` : "3px solid transparent",
                transform: i === activeIndex ? "scale(1.05)" : "scale(1)",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Box mb={1}>{stat.icon}</Box>
              <Typography variant="h5" fontWeight="bold" sx={{ color: stat.color }}>
                {stat.value}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
            </MotionPaper>
          ))}
        </Box>
      ) : (
        // 💻 Larger screens: grid
        <Grid container spacing={3} justifyContent="center">
          {statItems.map((stat, i) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
              <MotionPaper
                elevation={5}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                whileHover={{ scale: 1.05 }}
                sx={{
                  p: 3,
                  borderRadius: "18px",
                  textAlign: "center",
                  background: "#ffffff",
                  height: "100%",
                  boxShadow: "0px 4px 12px rgba(46,125,50,0.15)",
                }}
              >
                <Box mb={1}>{stat.icon}</Box>
                <Typography variant="h5" fontWeight="bold" sx={{ color: stat.color }}>
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.label}
                </Typography>
              </MotionPaper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default DashboardStats;
